import React from 'react';

// COMPONENTES
import DataTableNotification from './DataTableNotification';

export default function NotificationList(props) {
  const id = props.match.params.id;
  const postId = props.location.state.id;
  const sender = props.location.state.sender;

  return <DataTableNotification paramsId={id} postId={postId} sender={sender} />;
}
